(function () {
  'use strict';

  var ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  var STAGGER_MS = 25;

  var root = document.getElementById('ebook-page');
  if (!root) return;

  var sourceEl = document.getElementById('ebook-source');
  var gridEl = document.getElementById('eb-grid');
  var faqEl = document.getElementById('eb-faq');
  var railTrack = document.getElementById('eb-rail-track');
  var barTrack = document.getElementById('eb-bar-track');
  var searchInput = document.getElementById('eb-search-input');
  var searchHint = document.getElementById('eb-search-hint');
  var letterSectionsEl = document.getElementById('eb-letter-sections');
  var guideContentEl = document.getElementById('eb-guide-content');

  var currentHighlight = null;
  var currentLetter = null;
  var searchIndex = [];
  var cultivarsLoading = true;
  var scrollTicking = false;
  var handledInitialHash = false;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function trimText(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeText(value) {
    return trimText(value)
      .toLowerCase()
      .replace(/['’"]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function slugify(value) {
    var slug = normalizeText(value).replace(/\s+/g, '-');
    return slug || 'item';
  }

  function normalizeStorefrontUrl(href) {
    if (!href) return href;

    try {
      var parsed = new URL(href, window.location.origin);

      if (parsed.origin === window.location.origin) {
        return parsed.toString();
      }

      if (/^\/(pages|products|collections|blogs|search|cart|account)/.test(parsed.pathname)) {
        return window.location.origin + parsed.pathname + parsed.search + parsed.hash;
      }

      return parsed.toString();
    } catch (error) {
      return href;
    }
  }

  function uniqueItems(items, getKey) {
    var seen = {};
    var output = [];

    items.forEach(function (item) {
      var key = getKey(item);
      if (!key || seen[key]) return;
      seen[key] = true;
      output.push(item);
    });

    return output;
  }

  function getNodeDocument(rootNode) {
    return rootNode.nodeType === 9 ? rootNode : rootNode.ownerDocument;
  }

  function findWithinRootById(rootNode, id) {
    if (!id) return null;

    var doc = getNodeDocument(rootNode);
    var match = doc.getElementById(id);
    if (!match) return null;

    if (rootNode.nodeType === 9) return match;
    return rootNode.contains(match) ? match : null;
  }

  function getTopLevelNode(node, rootNode) {
    var current = node;
    while (current && current.parentNode && current.parentNode !== rootNode) {
      current = current.parentNode;
    }
    return current && current.parentNode === rootNode ? current : null;
  }

  function getMeaningfulText(node) {
    return trimText(node && node.textContent);
  }

  function isMeaningfulNode(node) {
    if (!node) return false;

    if (node.nodeType === 3) {
      return trimText(node.textContent) !== '';
    }

    if (node.nodeType !== 1) return false;

    var tag = node.tagName.toUpperCase();
    if (tag === 'BR') return false;
    if (tag === 'STYLE' || tag === 'SCRIPT') return false;
    if (tag === 'IMG' || tag === 'IFRAME') return true;

    return getMeaningfulText(node) !== '';
  }

  function getFirstMeaningfulChild(container, fromEnd) {
    var child = fromEnd ? container.lastChild : container.firstChild;

    while (child) {
      if (isMeaningfulNode(child)) return child;
      child = fromEnd ? child.previousSibling : child.nextSibling;
    }

    return null;
  }

  function trimContainerEdges(container) {
    var first = getFirstMeaningfulChild(container, false);
    while (container.firstChild && container.firstChild !== first) {
      container.removeChild(container.firstChild);
    }

    var last = getFirstMeaningfulChild(container, true);
    while (container.lastChild && container.lastChild !== last) {
      container.removeChild(container.lastChild);
    }
  }

  function removeDuplicateLeadingTitle(container, title) {
    var normalizedTitle = normalizeText(title);
    var first = getFirstMeaningfulChild(container, false);

    if (
      first &&
      first.nodeType === 1 &&
      /^(H[1-6]|P|DIV|SPAN)$/.test(first.tagName.toUpperCase()) &&
      normalizeText(first.textContent) === normalizedTitle
    ) {
      container.removeChild(first);
      trimContainerEdges(container);
    }
  }

  function removeTrailingStandaloneHeading(container, title) {
    var normalizedTitle = normalizeText(title);
    var last = getFirstMeaningfulChild(container, true);

    if (
      last &&
      last.nodeType === 1 &&
      /^H[1-6]$/.test(last.tagName.toUpperCase()) &&
      normalizeText(last.textContent) !== normalizedTitle
    ) {
      container.removeChild(last);
      trimContainerEdges(container);
    }
  }

  function removeEmptyDescendants(container) {
    toArray(container.querySelectorAll('*')).reverse().forEach(function (el) {
      var tag = el.tagName.toUpperCase();
      var hasMedia = !!el.querySelector('img, iframe, video, svg');

      if (tag === 'STYLE' || tag === 'SCRIPT') {
        el.parentNode.removeChild(el);
        return;
      }

      if (
        /^(P|DIV|SPAN|H[1-6])$/.test(tag) &&
        !hasMedia &&
        trimText(el.textContent) === ''
      ) {
        el.parentNode.removeChild(el);
      }
    });
  }

  function cleanNode(node, options, state) {
    if (node.nodeType === 3) {
      return trimText(node.textContent) === '' ? null : node;
    }

    if (node.nodeType !== 1) return null;

    var tag = node.tagName.toUpperCase();

    if (
      tag === 'STYLE' ||
      tag === 'SCRIPT' ||
      tag === 'NOSCRIPT' ||
      tag === 'META' ||
      tag === 'LINK'
    ) {
      return null;
    }

    if (tag === 'IMG') {
      var src = node.getAttribute('src') || '';

      if (
        /ReturnButton|NextVideo|PreviousVideo|RtnTop|ReturntoEbook|ViewPlant|Spacer/i.test(src)
      ) {
        return null;
      }

      node.removeAttribute('style');
      node.removeAttribute('align');
      node.removeAttribute('width');
      node.removeAttribute('height');
      node.setAttribute('loading', 'lazy');
      return node;
    }

    if (tag === 'A') {
      var href = node.getAttribute('href') || '';
      var image = node.querySelector('img');
      var imageSrc = image ? (image.getAttribute('src') || '') : '';
      var hasImage = !!image;

      if (href.charAt(0) === '#' && (hasImage || trimText(node.textContent) === '')) {
        return null;
      }

      if (
        hasImage &&
        /ViewPlant|ReturnButton|NextVideo|PreviousVideo|RtnTop|ReturntoEbook/i.test(imageSrc)
      ) {
        if (options.extractProductLinks && href.charAt(0) !== '#') {
          state.productHref = state.productHref || normalizeStorefrontUrl(href);
        }
        return null;
      }

      if (href && href.charAt(0) !== '#') {
        node.setAttribute('href', normalizeStorefrontUrl(href));
      }
    }

    node.removeAttribute('style');
    node.removeAttribute('align');
    node.removeAttribute('width');
    node.removeAttribute('height');
    node.removeAttribute('data-mce-fragment');
    node.removeAttribute('frameborder');

    if (tag === 'IFRAME') {
      node.setAttribute('loading', 'lazy');
      node.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      if (!node.getAttribute('title')) {
        node.setAttribute('title', state.title + ' video');
      }
      return node;
    }

    toArray(node.childNodes).forEach(function (child) {
      var cleanedChild = cleanNode(child, options, state);
      if (!cleanedChild) {
        node.removeChild(child);
      } else if (cleanedChild !== child) {
        node.replaceChild(cleanedChild, child);
      }
    });

    if (tag === 'A' && trimText(node.textContent) === '' && !node.querySelector('img, iframe')) {
      return null;
    }

    if (
      /^(P|DIV|SPAN|H[1-6])$/.test(tag) &&
      trimText(node.textContent) === '' &&
      !node.querySelector('img, iframe, video, svg, a')
    ) {
      return null;
    }

    if (/^H[1-6]$/.test(tag) && node.id && trimText(node.textContent) === '') {
      return null;
    }

    return node;
  }

  function sanitizeNodes(nodes, title, options) {
    var container = document.createElement('div');
    var state = {
      productHref: null,
      title: title,
    };

    nodes.forEach(function (node) {
      var clone = node.cloneNode(true);
      var cleaned = cleanNode(clone, options, state);
      if (cleaned) container.appendChild(cleaned);
    });

    trimContainerEdges(container);
    removeDuplicateLeadingTitle(container, title);
    trimContainerEdges(container);
    removeTrailingStandaloneHeading(container, title);
    trimContainerEdges(container);
    removeEmptyDescendants(container);
    trimContainerEdges(container);

    return {
      html: container.innerHTML,
      productHref: state.productHref,
    };
  }

  function extractIndexedSections(rootNode, indexItems, options) {
    var topNodes = toArray(rootNode.childNodes);

    var anchors = indexItems
      .map(function (item) {
        var anchorEl = findWithinRootById(rootNode, item.anchorId);
        var topLevelNode = anchorEl ? getTopLevelNode(anchorEl, rootNode) : null;
        var startIndex = topLevelNode ? topNodes.indexOf(topLevelNode) : -1;

        return startIndex === -1
          ? null
          : {
              item: item,
              startIndex: startIndex,
            };
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return a.startIndex - b.startIndex;
      });

    return anchors
      .map(function (entry, index) {
        var endIndex = index < anchors.length - 1
          ? anchors[index + 1].startIndex
          : topNodes.length;

        var slice = topNodes.slice(entry.startIndex, endIndex);
        var sanitized = sanitizeNodes(slice, entry.item.name, options);

        if (!trimText(sanitized.html)) return null;

        return {
          anchorId: entry.item.anchorId,
          name: entry.item.name,
          bodyHtml: sanitized.html,
          productHref: sanitized.productHref,
        };
      })
      .filter(Boolean);
  }

  function makeLetterSectionId(letter) {
    return 'eb-letter-' + letter.toLowerCase();
  }

  function makeCultivarId(letter, item) {
    return 'eb-cultivar-' + letter.toLowerCase() + '-' + slugify(item.anchorId || item.name);
  }

  function makeGuideId(item) {
    return 'eb-guide-' + slugify(item.anchorId || item.name);
  }

  function isNavigableLetter(item) {
    return item.active && (item.loading || item.count !== 0);
  }

  function parseMainContent() {
    var html = sourceEl ? sourceEl.innerHTML : '';
    var doc = new DOMParser().parseFromString(html, 'text/html');

    var letterMap = {};
    toArray(doc.querySelectorAll('a')).forEach(function (link) {
      var text = trimText(link.textContent);
      var href = link.getAttribute('href') || '';

      if (text.length === 1 && /^[A-Z]$/i.test(text) && href && href.charAt(0) !== '#') {
        letterMap[text.toUpperCase()] = href;
      }
    });

    var letters = ALPHABET.map(function (letter) {
      return {
        letter: letter,
        href: letterMap[letter] || null,
        active: !!letterMap[letter],
        loading: !!letterMap[letter],
        count: null,
      };
    });

    var guideIndex, guideSections;
    var guidesSourceEl = document.getElementById('ebook-guides-source');

    if (guidesSourceEl) {
      var guidesDoc = new DOMParser().parseFromString(guidesSourceEl.innerHTML, 'text/html');

      guideIndex = uniqueItems(
        toArray(guidesDoc.querySelectorAll('ul a[href^="#"]')).map(function (link) {
          var href = link.getAttribute('href') || '';
          return {
            anchorId: href.replace(/^#/, ''),
            name: trimText(link.textContent),
          };
        }),
        function (item) {
          return item.anchorId;
        }
      );

      guideSections = extractIndexedSections(guidesDoc.body, guideIndex, {
        extractProductLinks: false,
      }).map(function (item) {
        item.targetId = makeGuideId(item);
        return item;
      });
    } else {
      guideIndex = uniqueItems(
        toArray(doc.querySelectorAll('ul a[href^="#"]')).map(function (link) {
          var href = link.getAttribute('href') || '';
          return {
            anchorId: href.replace(/^#/, ''),
            name: trimText(link.textContent),
          };
        }),
        function (item) {
          return item.anchorId;
        }
      );

      guideSections = extractIndexedSections(doc.body, guideIndex, {
        extractProductLinks: false,
      }).map(function (item) {
        item.targetId = makeGuideId(item);
        return item;
      });
    }

    return {
      letters: letters,
      guideIndex: guideIndex,
      guideSections: guideSections,
      letterSections: [],
    };
  }

  function parseLetterPage(letter, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var sourceTemplate = doc.getElementById('ebook-letter-source');
    var contentDoc = sourceTemplate
      ? new DOMParser().parseFromString(sourceTemplate.innerHTML, 'text/html')
      : doc;
    var contentRoot = contentDoc.querySelector('.page-content.rte') ||
      contentDoc.querySelector('.page-content') ||
      contentDoc.body;

    var indexTable = toArray(contentRoot.querySelectorAll('table')).filter(function (table) {
      return !!table.querySelector('a[href^="#"]');
    })[0];

    if (!indexTable) {
      return {
        letter: letter,
        sectionId: makeLetterSectionId(letter),
        items: [],
      };
    }

    var indexItems = uniqueItems(
      toArray(indexTable.querySelectorAll('a[href^="#"]')).map(function (link) {
        var href = link.getAttribute('href') || '';
        return {
          anchorId: href.replace(/^#/, ''),
          name: trimText(link.textContent),
        };
      }),
      function (item) {
        return item.anchorId;
      }
    );

    var items = extractIndexedSections(contentRoot, indexItems, {
      extractProductLinks: true,
    }).map(function (item) {
      item.letter = letter;
      item.targetId = makeCultivarId(letter, item);
      return item;
    });

    return {
      letter: letter,
      sectionId: makeLetterSectionId(letter),
      items: items,
    };
  }

  function cardLabel(item) {
    if (!item.active || (!item.loading && item.count === 0)) return '—';
    if (item.loading) return 'Loading';
    if (typeof item.count === 'number') {
      return item.count === 1 ? '1 entry' : item.count + ' entries';
    }
    return 'Browse';
  }

  function cardHTML(item, index) {
    var navigable = isNavigableLetter(item);
    var tag = navigable ? 'button' : 'div';
    var cls = 'eb-card eb-card--' + (navigable ? 'active' : 'inactive');
    var delay = index * STAGGER_MS;

    if (item.loading) cls += ' eb-card--loading';
    if (currentLetter === item.letter) cls += ' eb-card--current';

    return (
      '<' + tag +
      ' class="' + cls + '"' +
      (navigable ? ' type="button"' : '') +
      (navigable ? ' data-letter-nav="' + item.letter + '"' : '') +
      ' data-letter="' + item.letter + '"' +
      ' data-animated style="animation-delay:' + delay + 'ms">' +
      '<span class="eb-card__letter">' + item.letter + '</span>' +
      '<span class="eb-card__label">' + escapeHTML(cardLabel(item)) + '</span>' +
      (navigable
        ? '<svg class="eb-card__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/></svg>'
        : '') +
      '</' + tag + '>'
    );
  }

  function railLetterHTML(item) {
    var navigable = isNavigableLetter(item);
    var tag = navigable ? 'button' : 'span';
    var cls = 'eb-rail__letter eb-rail__letter--' +
      (navigable ? 'active' : 'inactive');

    if (currentLetter === item.letter) cls += ' eb-rail__letter--current';

    return (
      '<' + tag +
      ' class="' + cls + '"' +
      (navigable ? ' type="button"' : '') +
      (navigable ? ' data-rail-letter="' + item.letter + '"' : '') + '>' +
      item.letter +
      '</' + tag + '>'
    );
  }

  function barLetterHTML(item) {
    var navigable = isNavigableLetter(item);
    var tag = navigable ? 'button' : 'span';
    var cls = 'eb-bar__letter eb-bar__letter--' +
      (navigable ? 'active' : 'inactive');

    if (currentLetter === item.letter) cls += ' eb-bar__letter--current';

    return (
      '<' + tag +
      ' class="' + cls + '"' +
      (navigable ? ' type="button"' : '') +
      (navigable ? ' data-bar-letter="' + item.letter + '"' : '') + '>' +
      item.letter +
      '</' + tag + '>'
    );
  }

  function faqCategoryIcon(name) {
    var n = normalizeText(name);
    if (n.indexOf('frost') !== -1 || n.indexOf('cold') !== -1 || n.indexOf('winter') !== -1) {
      return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="2" x2="12" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/><line x1="19.07" y1="4.93" x2="4.93" y2="19.07"/></svg>';
    }
    if (n.indexOf('soil') !== -1 || n.indexOf('fertiliz') !== -1 || n.indexOf('water') !== -1 || n.indexOf('drain') !== -1) {
      return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/></svg>';
    }
    if (n.indexOf('prune') !== -1 || n.indexOf('graft') !== -1 || n.indexOf('stak') !== -1) {
      return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 20h.01"/><path d="M7 20v-4"/><path d="M12 20v-8"/><path d="M17 20V8"/><path d="M22 4v16"/></svg>';
    }
    if (n.indexOf('aphid') !== -1 || n.indexOf('mite') !== -1 || n.indexOf('beetle') !== -1 || n.indexOf('spot') !== -1 || n.indexOf('mildew') !== -1) {
      return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
    }
    if (n.indexOf('spring') !== -1 || n.indexOf('fall') !== -1 || n.indexOf('checklist') !== -1 || n.indexOf('season') !== -1) {
      return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>';
    }
    if (n.indexOf('design') !== -1 || n.indexOf('garden') !== -1 || n.indexOf('hot') !== -1 || n.indexOf('heat') !== -1 || n.indexOf('climate') !== -1 || n.indexOf('mistake') !== -1 || n.indexOf('tip') !== -1 || n.indexOf('grow') !== -1) {
      return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22c4-4 8-7.5 8-12a8 8 0 1 0-16 0c0 4.5 4 8 8 12z"/><circle cx="12" cy="10" r="3"/></svg>';
    }
    return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>';
  }

  function faqItemHTML(item, index) {
    var delay = index * STAGGER_MS;

    return (
      '<button type="button" class="eb-faq__item" data-guide-nav="' + escapeHTML(item.targetId) + '"' +
      ' data-animated style="animation-delay:' + delay + 'ms">' +
      '<span class="eb-faq__icon">' +
      faqCategoryIcon(item.name) +
      '</span>' +
      '<span class="eb-faq__text">' + escapeHTML(item.name) + '</span>' +
      '<svg class="eb-faq__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
      '</button>'
    );
  }

  function cultivarIndexLinkHTML(item) {
    return (
      '<button type="button" class="eb-letter-section__chip" data-target-id="' + escapeHTML(item.targetId) + '">' +
      escapeHTML(item.name) +
      '</button>'
    );
  }

  function cultivarHTML(item) {
    return (
      '<article class="eb-cultivar" id="' + escapeHTML(item.targetId) + '" data-search-target data-letter="' + escapeHTML(item.letter) + '">' +
      '<header class="eb-cultivar__header">' +
      '<div>' +
      '<p class="eb-cultivar__eyebrow">' + escapeHTML(item.letter) + ' cultivar</p>' +
      '<h4 class="eb-cultivar__title">' + escapeHTML(item.name) + '</h4>' +
      '</div>' +
      (item.productHref
        ? '<a class="eb-cultivar__cta" href="' + escapeHTML(item.productHref) + '">View plant</a>'
        : '') +
      '</header>' +
      '<div class="eb-richtext eb-cultivar__body">' + item.bodyHtml + '</div>' +
      '</article>'
    );
  }

  function letterSectionHTML(section, index) {
    var delay = index * STAGGER_MS;
    var countLabel = section.items.length === 1
      ? '1 cultivar'
      : section.items.length + ' cultivars';

    return (
      '<section class="eb-letter-section" id="' + escapeHTML(section.sectionId) + '"' +
      ' data-letter-section="' + escapeHTML(section.letter) + '"' +
      ' data-animated style="animation-delay:' + delay + 'ms">' +
      '<div class="eb-letter-section__header">' +
      '<div>' +
      '<p class="eb-letter-section__eyebrow">Cultivars</p>' +
      '<h3 class="eb-letter-section__title">' + escapeHTML(section.letter) + '</h3>' +
      '</div>' +
      '<p class="eb-letter-section__count">' + escapeHTML(countLabel) + '</p>' +
      '</div>' +
      '<div class="eb-letter-section__index">' +
      section.items.map(cultivarIndexLinkHTML).join('') +
      '</div>' +
      '<div class="eb-cultivar-list">' +
      section.items.map(cultivarHTML).join('') +
      '</div>' +
      '</section>'
    );
  }

  function guideEyebrow(name) {
    var n = normalizeText(name);
    if (n.indexOf('aphid') !== -1 || n.indexOf('mite') !== -1 || n.indexOf('beetle') !== -1 || n.indexOf('spot') !== -1 || n.indexOf('mildew') !== -1) {
      return 'Pest &amp; Disease';
    }
    if (n.indexOf('frost') !== -1 || n.indexOf('cold') !== -1) {
      return 'Cold Weather Care';
    }
    if (n.indexOf('fertiliz') !== -1 || n.indexOf('soil') !== -1 || n.indexOf('water') !== -1 || n.indexOf('prune') !== -1 || n.indexOf('hot') !== -1 || n.indexOf('heat') !== -1 || n.indexOf('climate') !== -1) {
      return 'Growing Guide';
    }
    if (n.indexOf('graft') !== -1 || n.indexOf('stak') !== -1 || n.indexOf('mistake') !== -1 || n.indexOf('tip') !== -1) {
      return 'Technique &amp; Tips';
    }
    if (n.indexOf('spring') !== -1 || n.indexOf('fall') !== -1 || n.indexOf('checklist') !== -1) {
      return 'Seasonal Guide';
    }
    if (n.indexOf('design') !== -1 || n.indexOf('garden') !== -1) {
      return 'Garden Design';
    }
    return 'Care Guide';
  }

  function guideDisplayTitle(name) {
    var parts = name.split(/\s+\u2014\s+|\s+--\s+/);
    return parts.length > 1 ? trimText(parts.slice(1).join(' — ')) : name;
  }

  function guideHTML(item, index) {
    var delay = index * STAGGER_MS;
    var displayTitle = guideDisplayTitle(item.name);
    var bodyHtml = item.bodyHtml.replace(/^\s*<h[1-6][^>]*>[\s\S]*?<\/h[1-6]>\s*/i, '');

    return (
      '<article class="eb-guide" id="' + escapeHTML(item.targetId) + '"' +
      ' data-guide-target data-animated style="animation-delay:' + delay + 'ms">' +
      '<header class="eb-guide__header">' +
      '<div class="eb-guide__header-icon">' + faqCategoryIcon(item.name) + '</div>' +
      '<div class="eb-guide__header-text">' +
      '<p class="eb-guide__eyebrow">' + guideEyebrow(item.name) + '</p>' +
      '<h3 class="eb-guide__title">' + escapeHTML(displayTitle) + '</h3>' +
      '</div>' +
      '</header>' +
      '<div class="eb-richtext eb-guide__body">' + bodyHtml + '</div>' +
      '</article>'
    );
  }

  var FAQ_NAV_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>';

  function faqRailHTML() {
    return (
      '<button type="button" class="eb-rail__faq" data-faq-nav title="Questions &amp; Answers">' +
      FAQ_NAV_SVG +
      '</button>'
    );
  }

  function faqBarHTML() {
    return (
      '<button type="button" class="eb-bar__faq" data-faq-nav title="Questions &amp; Answers">' +
      FAQ_NAV_SVG +
      '</button>'
    );
  }

  function renderNavigation(letters) {
    if (gridEl) {
      gridEl.innerHTML = letters.map(cardHTML).join('');
    }

    if (railTrack) {
      railTrack.innerHTML = faqRailHTML() + letters.map(railLetterHTML).join('');
    }

    if (barTrack) {
      barTrack.innerHTML = faqBarHTML() + letters.map(barLetterHTML).join('');
    }
  }

  function renderGuides(guideSections) {
    if (!faqEl || !guideContentEl) return;

    if (!guideSections.length) {
      var guideSection = document.getElementById('eb-growing-section');
      var divider = root.querySelector('.eb-divider');

      if (guideSection) guideSection.style.display = 'none';
      if (divider) divider.style.display = 'none';
      return;
    }

    faqEl.innerHTML = guideSections.map(faqItemHTML).join('');
    guideContentEl.innerHTML = guideSections.map(guideHTML).join('');
  }

  function renderCultivars(letterSections) {
    if (!letterSectionsEl) return;

    if (!letterSections.length) {
      letterSectionsEl.innerHTML =
        '<div class="eb-grid__loading">No cultivar entries were available to load.</div>';
      return;
    }

    letterSectionsEl.innerHTML = letterSections.map(letterSectionHTML).join('');
  }

  function setCurrentLetter(letter) {
    if (currentLetter === letter) return;

    root.querySelectorAll('.eb-card--current').forEach(function (el) {
      el.classList.remove('eb-card--current');
    });
    root.querySelectorAll('.eb-rail__letter--current').forEach(function (el) {
      el.classList.remove('eb-rail__letter--current');
    });
    root.querySelectorAll('.eb-bar__letter--current').forEach(function (el) {
      el.classList.remove('eb-bar__letter--current');
    });

    currentLetter = letter || null;
    if (!currentLetter) return;

    var card = gridEl
      ? gridEl.querySelector('[data-letter="' + currentLetter + '"]')
      : null;
    var railLetter = railTrack
      ? railTrack.querySelector('[data-rail-letter="' + currentLetter + '"]')
      : null;
    var barLetter = barTrack
      ? barTrack.querySelector('[data-bar-letter="' + currentLetter + '"]')
      : null;

    if (card) card.classList.add('eb-card--current');
    if (railLetter) railLetter.classList.add('eb-rail__letter--current');
    if (barLetter) barLetter.classList.add('eb-bar__letter--current');
  }

  function highlightLetter(letter) {
    if (!letter || currentHighlight === letter) return;

    clearHighlight();
    currentHighlight = letter;

    var card = gridEl
      ? gridEl.querySelector('[data-letter="' + letter + '"]')
      : null;
    var railLetter = railTrack
      ? railTrack.querySelector('[data-rail-letter="' + letter + '"]')
      : null;
    var barLetter = barTrack
      ? barTrack.querySelector('[data-bar-letter="' + letter + '"]')
      : null;

    if (card) card.classList.add('eb-card--highlighted');
    if (railLetter) railLetter.classList.add('eb-rail__letter--highlighted');
    if (barLetter) barLetter.classList.add('eb-bar__letter--highlighted');
  }

  function clearHighlight() {
    if (!currentHighlight) return;

    root.querySelectorAll('.eb-card--highlighted').forEach(function (el) {
      el.classList.remove('eb-card--highlighted');
    });
    root.querySelectorAll('.eb-rail__letter--highlighted').forEach(function (el) {
      el.classList.remove('eb-rail__letter--highlighted');
    });
    root.querySelectorAll('.eb-bar__letter--highlighted').forEach(function (el) {
      el.classList.remove('eb-bar__letter--highlighted');
    });

    currentHighlight = null;
  }

  function pulseTarget(target) {
    if (!target) return;

    target.classList.remove('eb-target--pulse');
    target.offsetWidth;
    target.classList.add('eb-target--pulse');

    window.setTimeout(function () {
      target.classList.remove('eb-target--pulse');
    }, 1800);
  }

  function scrollToElement(target) {
    if (!target) return;

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });

    pulseTarget(target);
  }

  function scrollToHashTarget(options) {
    var hash = window.location.hash ? window.location.hash.replace(/^#/, '') : '';
    var target;

    if (!hash) return false;

    target = document.getElementById(hash);
    if (!target) return false;

    if (target.hasAttribute('data-letter-section')) {
      setCurrentLetter(target.getAttribute('data-letter-section'));
    } else if (target.hasAttribute('data-letter')) {
      setCurrentLetter(target.getAttribute('data-letter'));
    }

    if (options && options.silent) {
      target.scrollIntoView({
        behavior: 'auto',
        block: 'start',
      });
    } else {
      scrollToElement(target);
    }

    return true;
  }

  function scrollToLetter(letter) {
    var section = document.getElementById(makeLetterSectionId(letter));
    if (!section) return;

    setCurrentLetter(letter);
    highlightLetter(letter);
    scrollToElement(section);

    if (barTrack) {
      var barLetter = barTrack.querySelector('[data-bar-letter="' + letter + '"]');
      if (barLetter) {
        barLetter.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest',
        });
      }
    }

    window.setTimeout(clearHighlight, 1200);
  }

  function buildSearchIndex(data) {
    searchIndex = [];

    data.letterSections.forEach(function (section) {
      section.items.forEach(function (item) {
        searchIndex.push({
          type: 'cultivar',
          name: item.name,
          normalized: normalizeText(item.name),
          targetId: item.targetId,
          letter: item.letter,
        });
      });
    });

    data.guideSections.forEach(function (item) {
      searchIndex.push({
        type: 'guide',
        name: item.name,
        normalized: normalizeText(item.name),
        targetId: item.targetId,
      });
    });
  }

  function findSearchMatch(value) {
    var query = normalizeText(value);
    if (!query) return null;

    var startsWithMatch = null;
    var containsMatch = null;

    for (var i = 0; i < searchIndex.length; i++) {
      if (searchIndex[i].normalized.indexOf(query) === 0) {
        startsWithMatch = searchIndex[i];
        break;
      }
    }

    if (startsWithMatch) return startsWithMatch;

    for (var j = 0; j < searchIndex.length; j++) {
      if (searchIndex[j].normalized.indexOf(query) !== -1) {
        containsMatch = searchIndex[j];
        break;
      }
    }

    if (containsMatch) return containsMatch;

    if (/^[a-z]$/i.test(trimText(value))) {
      var letter = trimText(value).toUpperCase();
      var section = document.getElementById(makeLetterSectionId(letter));
      if (section) {
        return {
          type: 'letter',
          name: letter,
          targetId: section.id,
          letter: letter,
        };
      }
    }

    return null;
  }

  function updateSearchHint(match) {
    if (!searchHint) return;

    if (!match) {
      searchHint.textContent = cultivarsLoading
        ? 'Loading cultivars...'
        : 'No match';
      searchHint.classList.add('eb-search__hint--visible');
      return;
    }

    if (match.type === 'guide') {
      searchHint.textContent = '↵ Guide';
    } else if (match.type === 'letter') {
      searchHint.textContent = '↵ Letter ' + match.letter;
    } else {
      searchHint.textContent = '↵ ' + match.letter;
    }

    searchHint.classList.add('eb-search__hint--visible');
  }

  function clearSearchHint() {
    if (!searchHint) return;
    searchHint.textContent = '';
    searchHint.classList.remove('eb-search__hint--visible');
  }

  function goToSearchMatch(match) {
    if (!match) return;

    var target = document.getElementById(match.targetId);
    if (!target) return;

    if (match.letter) {
      setCurrentLetter(match.letter);
      highlightLetter(match.letter);
      window.setTimeout(clearHighlight, 1200);
    } else {
      clearHighlight();
    }

    scrollToElement(target);
  }

  function updateCurrentLetterFromScroll() {
    var sections = toArray(root.querySelectorAll('[data-letter-section]'));
    if (!sections.length) {
      setCurrentLetter(null);
      return;
    }

    var active = null;
    var threshold = 130;

    sections.forEach(function (section) {
      if (section.getBoundingClientRect().top <= threshold) {
        active = section.getAttribute('data-letter-section');
      }
    });

    if (!active && sections[0].getBoundingClientRect().top > threshold) {
      active = sections[0].getAttribute('data-letter-section');
    }

    setCurrentLetter(active);
  }

  function setupInteractions(data) {
    if (railTrack) {
      railTrack.addEventListener('mouseover', function (event) {
        var el = event.target.closest('[data-rail-letter]');
        if (!el) return;
        highlightLetter(el.getAttribute('data-rail-letter'));
      });

      railTrack.addEventListener('mouseleave', clearHighlight);

      railTrack.addEventListener('click', function (event) {
        var faqBtn = event.target.closest('[data-faq-nav]');
        if (faqBtn) {
          var faqSection = document.getElementById('eb-growing-section');
          if (faqSection) scrollToElement(faqSection);
          return;
        }
        var el = event.target.closest('[data-rail-letter]');
        if (!el) return;
        scrollToLetter(el.getAttribute('data-rail-letter'));
      });

      var dragging = false;

      function railLetterFromTouch(touch) {
        var letters = railTrack.querySelectorAll('[data-rail-letter]');

        for (var i = 0; i < letters.length; i++) {
          var rect = letters[i].getBoundingClientRect();
          if (touch.clientY >= rect.top && touch.clientY <= rect.bottom) {
            return letters[i].getAttribute('data-rail-letter');
          }
        }

        return null;
      }

      railTrack.addEventListener('touchstart', function (event) {
        dragging = true;
        var letter = railLetterFromTouch(event.touches[0]);
        if (letter) highlightLetter(letter);
        event.preventDefault();
      }, { passive: false });

      railTrack.addEventListener('touchmove', function (event) {
        if (!dragging) return;
        var letter = railLetterFromTouch(event.touches[0]);
        if (letter) highlightLetter(letter);
        event.preventDefault();
      }, { passive: false });

      railTrack.addEventListener('touchend', function () {
        dragging = false;
        if (currentHighlight) {
          scrollToLetter(currentHighlight);
        }
        window.setTimeout(clearHighlight, 800);
      });
    }

    if (barTrack) {
      barTrack.addEventListener('click', function (event) {
        var faqBtn = event.target.closest('[data-faq-nav]');
        if (faqBtn) {
          var faqSection = document.getElementById('eb-growing-section');
          if (faqSection) scrollToElement(faqSection);
          return;
        }
        var el = event.target.closest('[data-bar-letter]');
        if (!el) return;
        scrollToLetter(el.getAttribute('data-bar-letter'));
      });
    }

    if (gridEl) {
      gridEl.addEventListener('mouseover', function (event) {
        var card = event.target.closest('[data-letter]');
        if (!card) return;
        highlightLetter(card.getAttribute('data-letter'));
      });

      gridEl.addEventListener('mouseleave', clearHighlight);

      gridEl.addEventListener('click', function (event) {
        var card = event.target.closest('[data-letter-nav]');
        if (!card) return;
        scrollToLetter(card.getAttribute('data-letter-nav'));
      });
    }

    if (letterSectionsEl) {
      letterSectionsEl.addEventListener('click', function (event) {
        var button = event.target.closest('[data-target-id]');
        if (!button) return;

        var targetId = button.getAttribute('data-target-id');
        var target = targetId ? document.getElementById(targetId) : null;
        if (target) {
          var letter = target.getAttribute('data-letter');
          if (letter) setCurrentLetter(letter);
          scrollToElement(target);
        }
      });
    }

    if (faqEl) {
      faqEl.addEventListener('click', function (event) {
        var button = event.target.closest('[data-guide-nav]');
        if (!button) return;

        var targetId = button.getAttribute('data-guide-nav');
        var target = targetId ? document.getElementById(targetId) : null;
        if (target) scrollToElement(target);
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var value = trimText(searchInput.value);

        if (!value) {
          clearHighlight();
          clearSearchHint();
          return;
        }

        var match = findSearchMatch(value);

        if (match && match.letter) {
          highlightLetter(match.letter);
        } else {
          clearHighlight();
        }

        updateSearchHint(match);
      });

      searchInput.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;

        event.preventDefault();

        var match = findSearchMatch(searchInput.value);
        if (match) goToSearchMatch(match);
      });
    }

    window.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;

      (window.requestAnimationFrame || window.setTimeout)(function () {
        updateCurrentLetterFromScroll();
        scrollTicking = false;
      }, 16);
    }, { passive: true });

    window.addEventListener('hashchange', function () {
      scrollToHashTarget();
    });

    updateCurrentLetterFromScroll();
  }

  function loadCultivars(data) {
    var activeLetters = data.letters.filter(function (item) {
      return item.active && item.href;
    });

    if (!activeLetters.length) {
      cultivarsLoading = false;
      return Promise.resolve([]);
    }

    return Promise.all(
      activeLetters.map(function (item) {
        var url = normalizeStorefrontUrl(item.href);

        return fetch(url, {
          credentials: 'same-origin',
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Failed to load ' + item.letter + ' cultivars');
            }
            return response.text();
          })
          .then(function (html) {
            var section = parseLetterPage(item.letter, html);
            item.loading = false;
            item.count = section.items.length;
            return section;
          })
          .catch(function () {
            item.loading = false;
            item.count = 0;
            return {
              letter: item.letter,
              sectionId: makeLetterSectionId(item.letter),
              items: [],
            };
          });
      })
    ).then(function (sections) {
      cultivarsLoading = false;
      return sections.filter(function (section) {
        return section.items.length > 0;
      });
    });
  }

  function init() {
    var data = parseMainContent();

    renderNavigation(data.letters);
    renderGuides(data.guideSections);
    buildSearchIndex(data);
    setupInteractions(data);

    if (!handledInitialHash && scrollToHashTarget({ silent: true })) {
      handledInitialHash = true;
    }

    loadCultivars(data).then(function (letterSections) {
      data.letterSections = letterSections;
      renderNavigation(data.letters);
      renderCultivars(letterSections);
      buildSearchIndex(data);
      updateCurrentLetterFromScroll();

      if (window.location.hash) {
        scrollToHashTarget({ silent: handledInitialHash });
        handledInitialHash = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
